import decode from 'jwt-decode';
import {BaseService} from './BaseService';
export default class UserService extends BaseService {
  constructor(domain) {
    super(domain)
    this.getProfile = this.getProfile.bind(this)
  }
  getProfile() {
      // Using jwt-decode npm package to decode the token
      return decode(this.getToken());
  }
  getUsers() {
    return this.fetch(`${this.domain}/users`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }
  getExternalUsers() {
    return this.fetch(`${this.domain}/users/external`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }
  getReviewers() {
    return this.fetch(`${this.domain}/users/reviewers`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }
  getUser(id) {
    return this.fetch(`${this.domain}/user?id=${id}`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }
  createUser(username, email, roles, password, proyecto) {
      // Get a token from api server using the fetch api
      var currentUser = this.getProfile();
      var user = {
        "username": username,
        "email": email,
        "roles": roles,
        "password": password,
        "createdby": currentUser.username,
        "proyecto": proyecto === '' ? null : proyecto
      };
      console.log(user);
      return this.fetch(`${this.domain}/users`, {
          method: 'POST',
          body: JSON.stringify({
              user
            })
      }).then(res => {
          return Promise.resolve(res);
      })
  }
  getRoles() {
    return this.fetch(`${this.domain}/roles`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }
  updateUser(id, username, email, roles, password, proyecto) {
    var currentUser = this.getProfile();
    var user = {
      "id": id,
      "username": username,
      "email": email,
      "roles": roles,
      "createdby": currentUser.username,
      "proyecto": proyecto === '' ? null : proyecto
    };
    if (password){
      user.password = password;
    }
    console.log(user);

    return this.fetch(`${this.domain}/user`, {
        method: 'PUT',
        body: JSON.stringify({
            "user": user
          })
    }).then(res => {
        return Promise.resolve(res);
    })
  }
  deleteUser(id) {
    return this.fetch(`${this.domain}/user`, {
        method: 'DELETE',
        body: JSON.stringify({
            "user": {"id": id}
          })
    }).then(res => {
        return Promise.resolve(res);
    })
  }
  uploadUserAvatar (id, image) {
    const data = new FormData();
    data.append('file', image);
    data.append('user', id);

    return fetch(`${this.domain}/user/avatar`, {
          headers : {'Authorization':'Bearer ' + this.getToken()},
          method: 'POST',
          body: data,
        })
        .then(this._checkStatus)
        .then( response => {
          return Promise.resolve(response);
        });
  }
  getUserByRole(id) {
    const url = new URL(`${this.domain}/users/by-role`);
    const params = { id };
    url.search = new URLSearchParams(params)
    return this.fetch(url, {
      method: 'GET',
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/UserService.js